import React from "react";
import "../styles/Services.css";
import Footer from '../components/Footer';
import Services from "./Services";
import CompleteProjects from "../components/CompleteProjects";
import BookService from '../components/BookAppointmentSection';


function MainServices() {
  return (
     <div>
          <Services />
          <CompleteProjects />
          <BookService />
      <div><Footer /></div>
    </div>
  );
}

export default MainServices;
